module.exports = __webpack_public_path__ + "static/media/guide.68be9984.svg";